import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import { useTranslation, Trans } from "react-i18next";
import FrontText from "../FrontText";
import { Link } from "@inertiajs/react";
import FrontClassicButton from "../Buttons/FrontClassicButton";
import FrontPrimaryButton from "../Buttons/FrontPrimaryButton";
import FrontSmallContactButton from "../Buttons/FrontSmallContactButton";
import FrontRoundedButton from "../Buttons/FrontRoundedButton";

const ServicesCta = ({ headingKey, buttonLinkKey, buttonTextKey }) => {
    const { t } = useTranslation();

    return (
        <div className="bg-new-blue lg:py-15 md:py-12 py-10 lg:mb-20 md:mb-15 mb-10">
            <Container>
                <Row>
                    <Column className={`text-center`}>
                        <FrontText textSize={`20/24`} className="text-white font-bold mb-10">
                            <Trans i18nKey={headingKey}/>
                        </FrontText>
                        
                        <Link href={route(t(buttonLinkKey))} className="py-[10px] px-[18px] bg-30548A uppercase text-13 text-white font-semibold rounded-lg transition-all duration-300 ease-in-out hover:bg-yellow hover:text-black" title={t(buttonTextKey)}>
                            {t(buttonTextKey)}
                        </Link>
                    </Column>
                </Row>
            </Container>
        </div>
    )
}

export default ServicesCta;